import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {MODELS_NAME} from "../../../Apis/Models";
import {
    CreateListContractor,
    CreateListContractorEmployee, CreateListContractorVehicle,
    CreateListEmployee, CreateListEmployeeVehicle, CreateListSupplier,
    CreateListSupplierEmployee, CreateListSupplierVehicle,
    DownloadContractorEmployeeForm,
    DownloadContractorForm, DownloadContractorVehicleForm,
    DownloadEmployeeForm, DownloadEmployeeVehicleForm,
    DownloadSupplierEmployeeForm,
    DownloadSupplierForm, DownloadSupplierVehicleForm,
    UploadContractorEmployeeFormFile,
    UploadContractorFormFile, UploadContractorVehicleFormFile,
    UploadEmployeeFormFile, UploadEmployeeVehicleFormFile,
    UploadSupplierEmployeeFormFile, UploadSupplierFormFile, UploadSupplierVehicleFormFile
} from "../../../reduxToolkit/Files/FilesApi";
import routes from "../../../Routes/routes";
import {toast} from "react-toastify";
import {setExcelFile} from "../../../reduxToolkit/Files/FilesSlice";
import {getPhotoPicker, PHOTO_PICKER_MODEL} from '../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg} from '../../../Apis/functions';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const ImportFileApp = ({ model, show, onCreated, onHide }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [emptyFields, setEmptyFields] = useState(false);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [photoPickerFile, setPhotoPickerFile] = useState({...PHOTO_PICKER_MODEL})

    let DownloadForm;
    let UploadForm;
    let CreateList;

    switch (model) {
        case MODELS_NAME.employee:
            DownloadForm = DownloadEmployeeForm;
            UploadForm = UploadEmployeeFormFile;
            CreateList = CreateListEmployee;
            break;
        case MODELS_NAME.contractorEmployee:
            DownloadForm = DownloadContractorEmployeeForm;
            UploadForm = UploadContractorEmployeeFormFile;
            CreateList = CreateListContractorEmployee;
            break;
        case MODELS_NAME.supplierEmployee:
            DownloadForm = DownloadSupplierEmployeeForm;
            UploadForm = UploadSupplierEmployeeFormFile;
            CreateList = CreateListSupplierEmployee;
            break;
        case MODELS_NAME.contractor:
            DownloadForm = DownloadContractorForm;
            UploadForm = UploadContractorFormFile;
            CreateList = CreateListContractor;
            break;
        case MODELS_NAME.supplier:
            DownloadForm = DownloadSupplierForm;
            UploadForm = UploadSupplierFormFile;
            CreateList = CreateListSupplier;
            break;
        case MODELS_NAME.contractorVehicle:
            DownloadForm = DownloadContractorVehicleForm;
            UploadForm = UploadContractorVehicleFormFile;
            CreateList = CreateListContractorVehicle;
            break;
        case MODELS_NAME.supplierVehicle:
            DownloadForm = DownloadSupplierVehicleForm;
            UploadForm = UploadSupplierVehicleFormFile;
            CreateList = CreateListSupplierVehicle;
            break;
        case MODELS_NAME.employeeVehicle:
            DownloadForm = DownloadEmployeeVehicleForm;
            UploadForm = UploadEmployeeVehicleFormFile;
            CreateList = CreateListEmployeeVehicle;
            break;
    }

    const handleUploadFile = (e) => {
        let fileData = getPhotoPicker(photoPickerFile);
        if (fileData) {
            setEmptyFields(false);
            let formData = new FormData();
            dispatch(setExcelFile(fileData));
            formData.append('file', fileData);
            formData.append("id", contractorId || supplierId);

            dispatch(UploadForm(formData)).then(
                ({
                     payload: {
                         data: { data, code, success },
                     },
                 }) => {
                    if (success === true) {
                        const errorsArray = data?.filter((item) => item.errors !== null);

                        if (errorsArray.length > 0) {
                            switch (model) {
                                case MODELS_NAME.contractor:
                                    navigate(routes.contractor.importErrors);
                                    break;
                                case MODELS_NAME.supplier:
                                    navigate(routes.suppliers.importErrors);
                                    break;
                                case MODELS_NAME.contractorEmployee:
                                    navigate(routes.contractor.employeeImportErrors);

                                    break;
                                case MODELS_NAME.contractorVehicle:
                                    navigate(routes.vehicleContractor.importErrors);

                                    break;
                                case MODELS_NAME.supplierEmployee:
                                    navigate(routes.suppliers.employeeImportErrors);

                                    break;
                                case MODELS_NAME.supplierVehicle:
                                    navigate(routes.suppliers.vehicleImportErrors);

                                    break;
                                case MODELS_NAME.employeeVehicle:
                                    navigate(routes.vehicleFleet.importErrors);

                                    break;
                                case MODELS_NAME.employee:
                                    navigate(routes.employee.importErrors);

                                    break;
                            }
                        } else {
                            dispatch(CreateList(data)).then(
                                ({
                                     payload: {
                                         data: { data, code, success },
                                     },
                                 }) => {
                                    if (success === true) {
                                        onCreated();
                                        toast.success(t('has_been_created_successfully'));
                                    } else {
                                        errorMsg(code)
                                    }
                                },
                            );
                        }
                    } else {
                        errorMsg(code)
                    }
                },
            );

            onHide();
        } else {
            setEmptyFields(true);
        }
    };

    useEffect(() => {
        setEmptyFields(false);
        setPhotoPickerFile({...PHOTO_PICKER_MODEL});
    }, [show]);

    // Returning all necessary handlers and state for use in the component
    return {
        t,
        dispatch,
        emptyFields,
        handleUploadFile,
        DownloadForm,
        photoPickerFile,
        setPhotoPickerFile
    };
};

// Exporting the component for use in other parts of the application
export default ImportFileApp;
